<template>
    <div ref="columnContainer" class="d-flex col-sm-12" :class="defaultClasses">

        <component-renderer v-for="(component, componentIndex) in column.value" :containerWidth="containerWidth"
                            :component="component" :table="table" :document="document" :view="view"
                            :layout="layout" :key="componentKey(componentIndex)"></component-renderer>
    </div>
</template>

<script>
    import FieldRenderer from "../renderers/FieldRenderer.vue";
    import ComponentRenderer from "../renderers/ComponentRenderer.vue";
    import UIUtil from "../../utils/UIUtil";
    export default {
        name: 'ColumnRenderer',
        components: {ComponentRenderer, FieldRenderer},
        props: ['layout', 'row', 'index', 'document', 'table', 'column', 'view'],
        computed: {
            defaultClasses() {
                // return 'col-md-' + this.column.width + ' text-' + this.column.align + ' ' + this.directionClass
                let classes = 'col-md-' + this.column.width + ' ' + this.columnClasses + ' ' + this.cardClass
                return classes.trim()
            },
            columnClasses() {
                return this.justifyClass + ' ' + this.alignClass + ' ' + this.directionClass + ' ' +
                    this.marginClass + ' ' + this.paddingClass
            },
            justifyClass() {
                return this.isColumnOriented ? this.uiUtil.getJustifyClassColumn(this.column.justify) : this.uiUtil.getJustifyClassRow(this.column.justify)
            },
            alignClass() {
                return this.isColumnOriented ? this.uiUtil.getAlignClassColumn(this.column.align) : this.uiUtil.getAlignClassRow(this.column.align)
            },
            isColumnOriented() {
                return this.column.direction && this.column.direction === 'column'
            },
            cardClass() {
                return this.column.includeCard ? 'card shadow p-3' : ''
            },
            marginClass() {
                if(!this.column.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.column.margin)
            },
            paddingClass() {
                if(!this.column.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(this.column.padding)
            },
            field() {
                return this.column.value
            },
            fieldValue() {
                return this.document[this.field.index]
            },
            directionClass() {
                return this.column.direction && this.column.direction === 'column' ? 'flex-column' : 'flex-row'
            }
        },
        data() {
            return {
                uiUtil: new UIUtil(),
                model: webase.model,
                containerWidth: -1
            }
        },
        mounted() {
            this.containerWidth = this.$refs.columnContainer.offsetWidth
            console.log('ColumnRenderer W: ' + this.containerWidth)
        },
        updated() {
            this.containerWidth = this.$refs.columnContainer.offsetWidth
            console.log('ColumnRenderer W updated: ' + this.containerWidth)
        },
        methods: {
            componentKey(componentIndex) {
                return 'componentRenderer-' + this.table.id + this.index + componentIndex
            }
        }
    }
</script>

<style>

</style>
